/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminProfileResponseDto,
  AdminProfileUpdateDto,
  CancelDataSharingRequestsDto,
  CancelOperationResponseDto,
  ErrorResponse,
  GetPatientForProviderByIdResponseDto,
  PatientListResponseDto,
  PatientsPaginationRequestDto,
  RequestPatientDataSharingDto,
  RequestPatientDataSharingResponseDto,
} from '../models/index';
import {
    AdminProfileResponseDtoFromJSON,
    AdminProfileResponseDtoToJSON,
    AdminProfileUpdateDtoFromJSON,
    AdminProfileUpdateDtoToJSON,
    CancelDataSharingRequestsDtoFromJSON,
    CancelDataSharingRequestsDtoToJSON,
    CancelOperationResponseDtoFromJSON,
    CancelOperationResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetPatientForProviderByIdResponseDtoFromJSON,
    GetPatientForProviderByIdResponseDtoToJSON,
    PatientListResponseDtoFromJSON,
    PatientListResponseDtoToJSON,
    PatientsPaginationRequestDtoFromJSON,
    PatientsPaginationRequestDtoToJSON,
    RequestPatientDataSharingDtoFromJSON,
    RequestPatientDataSharingDtoToJSON,
    RequestPatientDataSharingResponseDtoFromJSON,
    RequestPatientDataSharingResponseDtoToJSON,
} from '../models/index';

export interface CancelPatientDataSharingForAdminRequest {
    cancelDataSharingRequestsDto: CancelDataSharingRequestsDto;
}

export interface GetAllPatientsRequest {
    patientsPaginationRequestDto: PatientsPaginationRequestDto;
}

export interface GetPatientDetailForAdminRequest {
    patientId: string;
}

export interface RequestPatientDataSharingForAdminRequest {
    requestPatientDataSharingDto: RequestPatientDataSharingDto;
}

export interface UpdateAdminProfileRequest {
    adminProfileUpdateDto: AdminProfileUpdateDto;
}

/**
 * 
 */
export class AdminApi extends runtime.BaseAPI {

    /**
     * Cancel one or multiple pending patient data sharing requests initiated by admin
     * Cancel pending patient data sharing requests
     */
    async cancelPatientDataSharingForAdminRaw(requestParameters: CancelPatientDataSharingForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CancelOperationResponseDto>> {
        if (requestParameters['cancelDataSharingRequestsDto'] == null) {
            throw new runtime.RequiredError(
                'cancelDataSharingRequestsDto',
                'Required parameter "cancelDataSharingRequestsDto" was null or undefined when calling cancelPatientDataSharingForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patient-data-sharing/cancel`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CancelDataSharingRequestsDtoToJSON(requestParameters['cancelDataSharingRequestsDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CancelOperationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Cancel one or multiple pending patient data sharing requests initiated by admin
     * Cancel pending patient data sharing requests
     */
    async cancelPatientDataSharingForAdmin(requestParameters: CancelPatientDataSharingForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CancelOperationResponseDto> {
        const response = await this.cancelPatientDataSharingForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the current admin\'s profile information
     * Get admin profile
     */
    async getAdminProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProfileResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProfileResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get the current admin\'s profile information
     * Get admin profile
     */
    async getAdminProfile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProfileResponseDto> {
        const response = await this.getAdminProfileRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all patients across all practices with pagination, search, and filter options
     * Get all patients
     */
    async getAllPatientsRaw(requestParameters: GetAllPatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PatientListResponseDto>> {
        if (requestParameters['patientsPaginationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'patientsPaginationRequestDto',
                'Required parameter "patientsPaginationRequestDto" was null or undefined when calling getAllPatients().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/query/nextPageToken`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PatientsPaginationRequestDtoToJSON(requestParameters['patientsPaginationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get all patients across all practices with pagination, search, and filter options
     * Get all patients
     */
    async getAllPatients(requestParameters: GetAllPatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PatientListResponseDto> {
        const response = await this.getAllPatientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve patient profile details and data-sharing context for administrators
     * Get patient details for admin
     */
    async getPatientDetailForAdminRaw(requestParameters: GetPatientDetailForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPatientForProviderByIdResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientDetailForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPatientForProviderByIdResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve patient profile details and data-sharing context for administrators
     * Get patient details for admin
     */
    async getPatientDetailForAdmin(requestParameters: GetPatientDetailForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPatientForProviderByIdResponseDto> {
        const response = await this.getPatientDetailForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request data sharing access for a patient on behalf of the admin
     * Request access to a patient profile
     */
    async requestPatientDataSharingForAdminRaw(requestParameters: RequestPatientDataSharingForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RequestPatientDataSharingResponseDto>> {
        if (requestParameters['requestPatientDataSharingDto'] == null) {
            throw new runtime.RequiredError(
                'requestPatientDataSharingDto',
                'Required parameter "requestPatientDataSharingDto" was null or undefined when calling requestPatientDataSharingForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patient-data-sharing/request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestPatientDataSharingDtoToJSON(requestParameters['requestPatientDataSharingDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RequestPatientDataSharingResponseDtoFromJSON(jsonValue));
    }

    /**
     * Request data sharing access for a patient on behalf of the admin
     * Request access to a patient profile
     */
    async requestPatientDataSharingForAdmin(requestParameters: RequestPatientDataSharingForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RequestPatientDataSharingResponseDto> {
        const response = await this.requestPatientDataSharingForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the current admin\'s profile information
     * Update admin profile
     */
    async updateAdminProfileRaw(requestParameters: UpdateAdminProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProfileResponseDto>> {
        if (requestParameters['adminProfileUpdateDto'] == null) {
            throw new runtime.RequiredError(
                'adminProfileUpdateDto',
                'Required parameter "adminProfileUpdateDto" was null or undefined when calling updateAdminProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/profile`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AdminProfileUpdateDtoToJSON(requestParameters['adminProfileUpdateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProfileResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update the current admin\'s profile information
     * Update admin profile
     */
    async updateAdminProfile(requestParameters: UpdateAdminProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProfileResponseDto> {
        const response = await this.updateAdminProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
